import React from 'react';

// Define SVG paths for your icons.
const icons = {
  home: (
    <> {/* Feather Icons: Home */}
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
      <polyline points="9 22 9 12 15 12 15 22"></polyline>
    </>
  ),
  compass: (
    <> {/* Feather Icons: Compass */}
      <circle cx="12" cy="12" r="10"></circle>
      <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>
    </>
  ),
  plus: (
    <> {/* Feather Icons: Plus */}
      <line x1="12" y1="5" x2="12" y2="19"></line>
      <line x1="5" y1="12" x2="19" y2="12"></line>
    </>
  ),
  bell: (
    <> {/* Feather Icons: Bell */}
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
    </>
  ),
  user: (
    <> {/* Feather Icons: User */}
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
    </>
  ),
  search: (
    <> {/* Feather Icons: Search */}
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </>
  ),
  heart: ( // Heart (outline)
    <> {/* Feather Icons: Heart */}
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
    </>
  ),
  // --- NEW: Filled Heart Icon ---
  'heart-filled': (
    <> {/* Custom filled heart (similar to Feather, but filled) */}
      <path fill="currentColor" d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
    </>
  ),
  // --- NEW: Comment Icon (renamed to 'comment' for clarity) ---
  comment: (
    <> {/* Feather Icons: Message Square - commonly used for comments */}
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
    </>
  ),
  // --- NEW: Repost Icon ---
  repost: (
    <> {/* Feather Icons: Repeat - commonly used for repost/retweet */}
      <polyline points="17 1 21 5 17 9"></polyline>
      <path d="M21 5H3v14"></path>
    </>
  ),
  // --- NEW: Arrow Up (for Boost) ---
  'arrow-up': (
    <> {/* Feather Icons: Arrow Up */}
      <line x1="12" y1="19" x2="12" y2="5"></line>
      <polyline points="5 12 12 5 19 12"></polyline>
    </>
  ),
  // --- NEW: Share Icon ---
  share: (
    <> {/* Feather Icons: Share */}
      <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
      <polyline points="16 6 12 2 8 6"></polyline>
      <line x1="12" y1="2" x2="12" y2="15"></line>
    </>
  ),
  // --- NEW: Eye Icon (for Views) ---
  eye: (
    <> {/* Feather Icons: Eye */}
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
      <circle cx="12" cy="12" r="3"></circle>
    </>
  ),
  bookmark: ( // Bookmark (outline) - renamed for consistency
    <> {/* Feather Icons: Bookmark */}
      <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
    </>
  ),
  // --- NEW: Filled Bookmark Icon ---
  'bookmark-filled': (
    <> {/* Custom filled bookmark */}
      <path fill="currentColor" d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
    </>
  ),
  'message-square': ( // Your existing message-square, keeping it as an alias or for other uses
    <> {/* Feather Icons: Message Square */}
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
    </>
  ),
  'logo-Z': (
    <>
      <rect x="2" y="2" width="20" height="20" rx="4" ry="4"></rect>
      <line x1="6" y1="12" x2="18" y2="12"></line>
      <line x1="12" y1="6" x2="12" y2="18"></line>
    </>
  ),
  'plus-circle': (
    <> {/* Feather Icons: Plus Circle */}
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="16"></line>
      <line x1="8" y1="12" x2="16" y2="12"></line>
    </>
  ),
  'info-circle': (
    <>
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="16" x2="12" y2="12"></line>
      <line x1="12" y1="8" x2="12.01" y2="8"></line>
    </>
  ),
  'settings': (
    <> {/* Feather Icons: Settings */}
      <circle cx="12" cy="12" r="3"></circle>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l-.06.06a2 2 0 0 1-2.83 2.83l-.06.06a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82l-.06.06a2 2 0 0 1-2.83-2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33l-.06-.06a2 2 0 0 1-2.83-2.83l-.06-.06a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06-.06a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l.06.06a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33l-.06-.06a2 2 0 0 1-2.83 2.83z"></path>
    </>
  ),
  'logout-outline': (
    <> {/* Feather Icons: Log Out */}
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
      <polyline points="16 17 21 12 16 7"></polyline>
      <line x1="21" y1="12" x2="9" y2="12"></line>
    </>
  ),
  'map': (
    <> {/* Feather Icons: Map */}
      <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon>
      <line x1="8" y1="2" x2="8" y2="18"></line>
      <line x1="16" y1="6" x2="16" y2="22"></line>
    </>
  ),
  'play-circle': (
    <> {/* Feather Icons: Play Circle */}
      <circle cx="12" cy="12" r="10"></circle>
      <polygon points="10 8 16 12 10 16 10 8"></polygon>
    </>
  ),
  'shopping-bag': (
    <> {/* Feather Icons: Shopping Bag */}
      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
      <line x1="3" y1="6" x2="21" y2="6"></line>
      <path d="M16 10a4 4 0 0 1-8 0"></path>
    </>
  ),
  'more-options': ( // Renamed from 'ellipsis-h' for clarity in PostCard
    <> {/* Feather Icons: More Horizontal (three horizontal dots) */}
      <circle cx="12" cy="12" r="1"></circle>
      <circle cx="19" cy="12" r="1"></circle>
      <circle cx="5" cy="12" r="1"></circle>
    </>
  ),
  'menu': (
    <> {/* Feather Icons: Menu (hamburger icon) */}
      <line x1="3" y1="12" x2="21" y2="12"></line>
      <line x1="3" y1="6" x2="21" y2="6"></line>
      <line x1="3" y1="18" x2="21" y2="18"></line>
    </>
  ),
  // --- NEW: Checkmark Circle Filled Icon for Verified Badge ---
  'check-circle-filled': (
    <>
      <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
    </>
  ),
    // --- NEW: Flag Icon for Report ---
  'flag': (
    <> {/* Feather Icons: Flag */}
        <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
        <line x1="4" y1="22" x2="4" y2="15"></line>
    </>
  ),
  // --- NEW: Link Icon for Copy Link ---
  'link': (
    <> {/* Feather Icons: Link */}
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07L13.54 9.54a5 5 0 0 0-7.07 7.07l3-3a5 5 0 0 0 7.07 0"></path>
    </>
  ),
  // --- NEW: Mute Icon ---
  'mute': (
    <> {/* Feather Icons: Volume X (volume muted) */}
        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
        <line x1="23" y1="9" x2="17" y2="15"></line>
        <line x1="17" y1="9" x2="23" y2="15"></line>
    </>
  ),
  // --- NEW: User Block Icon ---
  'user-block': (
    <> {/* Combination of user and slash/block */}
        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="8.5" cy="7" r="4"></circle>
        <line x1="17" y1="11" x2="23" y2="17"></line>
        <line x1="23" y1="11" x2="17" y2="17"></line>
    </>
  ),
  // --- NEW: User Unblock Icon ---
  'user-unblock': (
    <> {/* User plus an outline of an unblock/arrow */}
        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="8.5" cy="7" r="4"></circle>
        <path d="M17 14l3-3 3 3"></path>
        <path d="M20 17h-3V11"></path>
    </>
  ),
  // --- NEW: Play (for video overlay if controls hidden) ---
  'play': (
    <> {/* Feather Icons: Play */}
      <polygon points="5 3 19 12 5 21 5 3"></polygon>
    </>
  ),
  // --- NEW: Arrow Right (for CTA button) ---
  'arrow-right': (
    <> {/* Feather Icons: Arrow Right */}
      <line x1="5" y1="12" x2="19" y2="12"></line>
      <polyline points="12 5 19 12 12 19"></polyline>
    </>
  ),
};

const Icon = ({ name, size = 24, color = 'currentColor', className = '', style = {}, ...props }) => {
  const IconSvgPaths = icons[name];

  if (!IconSvgPaths) {
    // console.warn(`Icon not found: ${name}. Displaying fallback.`); // Keep this for debugging missing icons
    // Fallback: Default info-circle icon for missing ones
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={className.includes('interaction-item') ? color : 'currentColor'} // Keep interaction items colored
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={`icon icon-fallback ${className}`}
        style={style}
        aria-label={`icon ${name || 'unknown'}`}
        {...props}
      >
        {/* 'info-circle' SVG for fallback */}
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="16" x2="12" y2="12"></line>
        <line x1="12" y1="8" x2="12.01" y2="8"></line>
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      // Fill is none by default, stroke is currentColor. For filled icons, path should have fill="currentColor"
      fill="none" 
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`icon icon-${name} ${className}`}
      style={style}
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      {IconSvgPaths}
    </svg>
  );
};

export default Icon;